import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';
import { navSelector } from '../../../../store/js/modules/video-hub/nav/selectors/nav-selector';

export const NavItem = ({ label, onClick }) => {
    const nav = useSelector(navSelector);
    const isActive = Number(nav.round) === label;

    return (
        <li
            className={`video-hub__round-list-item ${
                isActive ? 'is-active' : ''
            }`}
        >
            <button
                className="video-hub__round-list-button"
                onClick={(event) => onClick(event, label)}
            >
                {label}
            </button>
        </li>
    );
};

NavItem.propTypes = {
    label: PropTypes.number,
    onClick: PropTypes.func
};
